<template>
  <SfModal
    v-e2e="'size-modal'"
    :visible="openPopUp"
    class="modal-size-chart"
    @close="closeModal"
  >
    <template #modal-bar>
      <SfBar
        class="sf-modal__bar smartphone-only"
        :close="true"
        :title="$t('Size specifications')"
        @click:close="closeModal"
      />
    </template>
    <div v-if="sizeChart && sizeChart.tables">
      <div
        v-for="(table,indexTable) in sizeChart.tables"
        :key="'size-chart-'+indexTable"
      >
        <h4 class="title">
          {{ table.title }}
        </h4>
        <div class="table-wrap">
          <HTMLContent
            :content="table.content"
          />
        </div>
      </div>
    </div>
  </SfModal>
</template>

<script>
import { contentGetters, useContent } from '@vue-storefront/gemini';
import { computed } from '@nuxtjs/composition-api';
import {
  SfBar,
  SfModal,
} from '@storefront-ui/vue';
import { useI18n } from '../helpers/hooks/usei18n';
import HTMLContent from '~/components/HTMLContent';

export default {
  name: 'SizeChart',
  components: {
    SfBar,
    SfModal,
    HTMLContent,
  },
  props: {
    openPopUp: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { locale } = useI18n();

    const {
      blocks,
    } = useContent(`cmsBlockFooter-${locale}`);
    const identifierSize = `size-chart-${locale}`;

    return {
      blocks,
      identifierSize,
    };
  },
  data() {
    return {
      closeModalTest: false,
    };
  },
  computed: {
    sizeChart() {
      return computed(() => contentGetters.getCmsBlockContent(this.blocks)).value[this.identifierSize];
    },
  },
  methods: {
    closeModal() {
      this.$emit('modalClosed');
    },
  },
};
</script>

<style lang="scss">
  .modal-size-chart {
    .sf-modal__overlay {
      z-index: 99;
    }
    .sf-modal__container {
      width: 100%;
      z-index: 100;

      .title {
        line-height: 100px;
        text-align: center;
      }

      .table-wrap {
        width: 100%;
        overflow-x: auto;
        margin-bottom: 50px;
      }

      table {
        width: 100%;
        border-collapse: collapse;
        //table-layout: fixed;

        .first {
          text-align: left;
          width: 120px;
        }

        tr {
          border-bottom: 1px solid #000;
        }

        td {
          text-align: center;
          padding: 10px;
          display: table-cell;
          white-space: nowrap;
          border-right: 1px solid #000;
        }

        td:last-of-type {
          border-right: none;
        }
      }
    }

    @include for-desktop {
      .sf-modal__container {
        width: 85vw;
        max-width: 1100px;

        /*table {*/
        /*  width: 95%;*/
        /*  margin: 0 auto;*/
        /*}*/
      }
    }
  }
</style>
